import { EpimsBankDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EpimsBankService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getEpimsBank(): Observable<EpimsBankDto[]> {
    return this.http.get<EpimsBankDto[]>(this.url + 'bank');
  }

  createEpimsBank(data: EpimsBankDto[]): Observable<EpimsBankDto[]> {
    return this.http.post<EpimsBankDto[]>(this.url + 'bank', data);
  }
  getSingleEpimsBank(id: string): Observable<any> {
    return this.http.get(this.url + 'bank/' + id);
  }

  updateEpimsBank(data: EpimsBankDto[]): Observable<EpimsBankDto[]> {
    return this.http.post<EpimsBankDto[]>(this.url + 'bank/update', data);
  }

  deleteEpimsBank(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('bank', ids.join(', '));
    return this.http.delete(this.url + 'bank', httpOptions);
  }
}
